module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.eot?12d26c285b71d790f4b0c94423ef1f99";